import React from 'react';
import rest from '@data/restWrapper';
import FeatureFlag from '@components/FeatureFlag';
import { translate } from '@data/translations';
import { setModalContent, closeModal } from '@components/modal';
import { RoomInfoEditModel } from '@common/modelDefinition';

interface GuestInterface {
    code: number;
    validToTimestamp: number;
    cardCodeType: string;
}

interface ConfirmationModalProps {
    title?: string;
    callback?: any;
}

async function setCardCodeWithValidToTime(remoteDeviceId: string, guest: GuestInterface) {
    try {
        await rest('/src/setCardCodeWithValidToTime/' + remoteDeviceId, 'POST', guest);
    } catch (err: any) {
        console.warn(err);
    }
}

export const hardwareClearRoomCodes = async (room: RoomInfoEditModel) => {
    const remoteDevices = [room?.remoteDeviceId, room?.remoteDeviceId2, room?.remoteDeviceId3];
    for (const deviceId of remoteDevices) {
        if (room && deviceId) {
            const guest1: GuestInterface = {
                code: 0,
                validToTimestamp: Date.now(),
                cardCodeType: 'guest1',
            };
            const guest2: GuestInterface = {
                code: 0,
                validToTimestamp: Date.now(),
                cardCodeType: 'guest2',
            };
            const guest3: GuestInterface = {
                code: 0,
                validToTimestamp: Date.now(),
                cardCodeType: 'guest3',
            };
            //treba provjeriti zasto se ne salje ID rezervacije
            await setCardCodeWithValidToTime(deviceId, guest1);
            await setCardCodeWithValidToTime(deviceId, guest2);
            await setCardCodeWithValidToTime(deviceId, guest3);
        }
    }
};

const showConfirmationModal = (props: ConfirmationModalProps) => {
    const { title, callback } = props;
    setModalContent(
        <div className="">
            <div className="text-center">
                {translate('Please confirm.')}
                <hr />
            </div>

            <div className="flex-center-center">
                <button
                    onClick={() => {
                        closeModal();
                    }}
                    className="button-secondary mr-8p"
                >
                    {translate('Cancel')}
                </button>
                <button
                    onClick={async () => {
                        callback();
                        closeModal();
                    }}
                    className="button-primary ml-8p"
                >
                    {translate('Confirm')}
                </button>
            </div>
        </div>,

        title, // header
        false, // showCloseButton
        'modal-md'
    );
};

interface SRCClearRoomCodesProps {
    roomInfo: RoomInfoEditModel;
    className: string;
}

function SRCClearRoomCodes(props: SRCClearRoomCodesProps) {
    const { roomInfo, className } = props;

    if (!roomInfo.remoteDeviceId && !roomInfo.remoteDeviceId2 && !roomInfo.remoteDeviceId3) {
        return <div className={`${className}`}>{translate('Clear access codes')} (no HW binding)</div>;
    }

    return (
        <FeatureFlag flag={'hardware'}>
            <button
                className={`button-warning uppercase ${className}`}
                onClick={() => {
                    const confirmationModalProps: ConfirmationModalProps = {
                        title: translate('Clear room access codes'),
                        callback: () => {
                            hardwareClearRoomCodes(roomInfo);
                        },
                    };
                    showConfirmationModal(confirmationModalProps);
                }}
            >
                {translate('CLEAR ROOM CODES')}
            </button>
        </FeatureFlag>
    );
}

export { SRCClearRoomCodes };
